import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { translate } from 'react-switch-lang';
import TooltipedIconButton from './Base/TooltipedIconButton';

function AddButton({
  onClick, id, t, text, className,
}) {
  return (
    <TooltipedIconButton
      text={text}
      onClick={onClick}
      id={id}
      className="btn btn-outline-light"
      icon={`fa fa-plus ${className}`}
    />
  );
}

AddButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default translate(AddButton);
